var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2H12.773C16.033 2 17.665 2 18.797 2.798C19.121 3.026 19.409 3.298 19.652 3.603C20.5 4.669 20.5 6.203 20.5 9.273V11.818C20.5 14.781 20.5 16.263 20.031 17.446C19.277 19.349 17.683 20.849 15.661 21.559C14.404 22 12.831 22 9.681 22C7.883 22 6.983 22 6.265 21.748C5.11 21.342 4.199 20.485 3.768 19.398C3.5 18.722 3.5 17.875 3.5 16.182V12",
    stroke: "#28325A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12C20.5 12.884 20.1488 13.7317 19.5238 14.3568C18.8987 14.9818 18.051 15.333 17.167 15.333C16.501 15.333 15.716 15.217 15.069 15.39C14.7864 15.466 14.5288 15.6149 14.3218 15.8218C14.1149 16.0288 13.966 16.2864 13.89 16.569C13.717 17.216 13.833 18.001 13.833 18.667C13.833 19.1047 13.7468 19.5381 13.5793 19.9425C13.4118 20.3469 13.1663 20.7143 12.8568 21.0238C12.5473 21.3333 12.1799 21.5788 11.7755 21.7463C11.3711 21.9138 10.9377 22 10.5 22M4.5 4.5C4.992 3.994 6.3 2 7 2M7 2C7.7 2 9.008 3.994 9.5 4.5M7 2V10",
    stroke: "#28325A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUpload);
export default __webpack_public_path__ + "static/media/bulk_upload.1b85e433e60d50951471331bd00abacc.svg";
export { ForwardRef as ReactComponent };